import { message, Modal, notification, Select } from "antd";
import React, { useEffect, useState } from "react";
import Utils from "../../../../../utils/Utils";
import WebUtils from "../../../../../utils/WebUtils";
import { getResumeDropDown } from "../../../../../api/b2b-candidate";
import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";
import { getAllJdsApi } from "../../../../../api/candidate";
import { compareResumeJd } from "../../../../../api/org-admin";

const { Option } = Select;

function MatchResumeModal({ matchResumeFlag, setMatchResumeFlag, setLoading }) {
  const userDetail = Utils.getUserDetail();
  const navigate = useNavigate();

  const [resumeDropdownList, setResumeDropdownList] = useState([]);
  const [selectedList, setSelectedList] = useState(null);
  const [allJobs, setAllJobs] = useState(null);
  const [jdId, setJdId] = useState(null);
  const [resumeFileName, setResumeFileName] = useState(null);
  const [jdName, setJdName] = useState(null);

  const getResumeDropdownApi = () => {
    const url = `${getResumeDropDown}?organizationId=${
      userDetail?.organizationId || null
    }&userIdentifier=${userDetail?.userIdentifier}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setResumeDropdownList(result?.data?.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getAllJds = async () => {
    let url = "";
    if (userDetail?.userRole === "JOBDRONA_CANDIDATE") {
      url = `${getAllJdsApi}?userIdentifier=${userDetail?.userIdentifier || null}`;
    } else {
      url = `${getAllJdsApi}?userIdentifier=${
        userDetail?.userIdentifier || null
      }&organizationId=${userDetail.organizationId}`;
    }
    setLoading(true);
    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setAllJobs(result.data.data);
        } else {
          setAllJobs(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const compareApi = async () => {
    const url = `${compareResumeJd}`;

    if (!selectedList) {
      message.error("Please select a resume");
      return;
    }
    if (!jdId) {
      message.error("Please select a JD");
      return;
    }

    let reqBody = {
      organizationId: userDetail.organizationId,
      resumeIdentifier: selectedList,
      resumeFileName: resumeFileName,
      userIdentifier: userDetail.userIdentifier,
      jobTitle: jdName,
      jdIdentifier: jdId,
      language: "English",
      additionalInstructions: "",
    };

    setLoading(true);
    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          navigate(`/cv-optimizer?tab=report`);
        } else {
          notification.error({
            message: "Failed",
            description: result?.data?.resultStatusInfo?.message,
            placement: "topRight",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const resumeOptions = Array.from(
    new Map([
      ...(resumeDropdownList || [])?.map((item) => [
        item.resumeIdentifier,
        {
          label: (
            <div>
              <p className="font-medium mb-0">
                {item.resumeFileName}{" "}
                <span className="text-[.75rem] text-gray-500">
                  ({item.resumeIdentifier})
                </span>
              </p>

              <p className="text-[.75rem] text-gray-500 mb-0">
                Uploaded on{" "}
                {new Date(item.uploadedDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
              <p className="text-[.75rem] text-gray-500 mb-0">
                {item.resumeOptimizerState}
              </p>
            </div>
          ),

          value: item.resumeIdentifier,
          title: item.resumeFileName,
        },
      ]),
    ]).values(),
  );

  useEffect(() => {
    getResumeDropdownApi();
    getAllJds();
  }, []);

  const handleSubmit = () => {
    compareApi();
  };

  return (
    <Modal
      open={matchResumeFlag}
      onCancel={() => setMatchResumeFlag(false)}
      centered
      footer={null}
      title={
        <div className="flex items-center gap-[.5rem] text-[1rem]">
          <FileText size={19} />
          <span>Match Resume</span>
        </div>
      }
    >
      <div className="mt-5">
        <p>Select resume </p>
        <Select
          //   allowClear
          className="w-full mt-1"
          size="large"
          placeholder="Select resume"
          value={selectedList}
          labelInValue
          onChange={(option) => {
            setSelectedList(option.value);
            setResumeFileName(option.title);
          }}
          options={resumeOptions}
          optionLabelProp="title"
        />
      </div>
      <div className="mt-5">
        <p>Select JD</p>
        <Select
          className="w-full mt-1"
          size="large"
          placeholder="Select a job role"
          optionLabelProp="title"
          value={jdId}
        >
          {allJobs?.map((job) => (
            <Option
              key={job?.jdIdentifier}
              value={job?.jdIdentifier}
              title={job?.jobTitle}
            >
              <div
                onClick={() => {
                  setJdId(job?.jdIdentifier);
                  setJdName(job?.jobTitle);
                }}
                className="flex flex-col"
              >
                <div className="flex justify-between items-center">
                  <span className="font-medium text-gray-800">
                    {job.jobTitle}
                  </span>
                  <span className="text-sm text-gray-500">
                    {job.jdIdentifier}
                  </span>
                </div>
                <div className="flex justify-between text-sm text-gray-600">
                  <span>{job.companyName}</span>
                  <span>{job.yearsOfExperience} yrs</span>
                </div>
              </div>
            </Option>
          ))}
        </Select>
      </div>
      {userDetail?.userRole === "JOBDRONA_CANDIDATE" && (
        <div className="mt-3 text-red-500">
          <strong>Note</strong> :{" "}
          <span>
            <strong>15</strong> credits will be detected for every AI generation
          </span>
        </div>
      )}
      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={() => setMatchResumeFlag(false)}
        >
          Cancel
        </button>

        <button
          //   disabled={selectedBatchGuides?.length < 1}
          onClick={() => handleSubmit()}
          className={` btn-orange px-3 py-2 rounded-lg sm:w-1/2 w-full`}
        >
          Compare
        </button>
      </div>
    </Modal>
  );
}

export default MatchResumeModal;
